export default __webpack_public_path__ + "static/media/title_mob.c7c5e171.svg";